import { Injectable, OnDestroy } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CookieCustomService } from '../services/cookie.custom.service';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';
import { selectGoodModeType } from '../store/goodmode/goodmode.selectors';
import { UserRolesEnum } from '../interfaces/user.interface';

@Injectable()
export class TokenInterceptor implements HttpInterceptor, OnDestroy {
  destroySubject$: Subject<void> = new Subject();

  constructor(
    private localStorage: CookieCustomService,
    private store: Store
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let serverReq: HttpRequest<any> = request;
    if (request) {
      this.store
        .select(selectGoodModeType)
        .pipe(takeUntil(this.destroySubject$))
        .subscribe(type => {
          let token = null;

          if (type === UserRolesEnum.admin) {
            token = this.localStorage.getItem(environment.adminToken);
          }

          if (type === UserRolesEnum.receiver) {
            token = this.localStorage.getItem(environment.frontToken);
          }

          if (token && request.url.indexOf('s3.') === -1) {
            Object.assign(request, {
              setHeaders: {
                Authorization: token,
              },
            });
          }

          serverReq = request.clone(request);
        });
    }

    return next.handle(serverReq);
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.unsubscribe();
  }
}
